<div class="flex-card-wrapper">
    <div class="container-lg">
        <div class="col-12 offset-md-2 col-md-8 text-center">
            <h2 class="flex-card-main-header" [innerHTML]="block.data.text ? block.data.text : block.data.heading"></h2>
        </div>

        <div class="flex-card-wrapper-row">
            <div class="flex-card-single" *ngFor="let block of block.content trackBy: trackByFn; let index = index;">
                <img src="{{block.data.image}}" class="flex-card-single__image" alt="">
                <p class="flex-card-header">{{block.data.headerText}}</p>
                <p class="flex-card-content">{{block.data.contentText}}</p>
            </div>
        </div>

        <div class="col-12 offset-md-2 col-md-8 text-center flex-button">
            <a href="{{block.data.link}}" class="btn btn-primary image-text-block__button" target="{{block.data.target}}" *ngIf="block.data.buttonText && block.data.link">{{block.data.buttonText}}</a>
        </div>
    </div>
</div>
